import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "code-cell-output" }
const _hoisted_2 = ["onClickCapture"]
const _hoisted_3 = { key: 3 }

import { ref, inject } from "vue";
import BeakerMimeBundle from "../render/BeakerMimeBundle.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BeakerCodeCellOutput',
  props: [
    "outputs",
    "busy"
],
  setup(__props) {

const props = __props;

const collapseOutput = (output) => {
    const metadata = ref(output?.metadata || (output.metadata = {}))
    metadata.value.collapsed = !metadata.value.collapsed;
}

const rebundleError = (errorOutput) => {
    const traceback = (Array.isArray(errorOutput.traceback) ? errorOutput.traceback?.join('\n') : errorOutput.traceback?.toString());
    const bundle = {
        'application/vnd.jupyter.error':  errorOutput,
        'application/vnd.jupyter.stderr': traceback || `${errorOutput.ename}: ${errorOutput.evalue}`,
    }
    return bundle;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.outputs, (output) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["code-cell-output-box", {'collapsed-output': output.metadata?.collapsed}]),
        key: output
      }, [
        _createElementVNode("div", {
          class: "output-collapse-box",
          onClickCapture: _withModifiers(($event: any) => (collapseOutput(output)), ["stop","prevent"])
        }, null, 40, _hoisted_2),
        (output.output_type == 'stream')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(output.output_type)
            }, _toDisplayString(output.text), 3))
          : (['display_data', 'execute_result'].includes(output.output_type))
            ? (_openBlock(), _createBlock(BeakerMimeBundle, {
                key: 1,
                "mime-bundle": output.data,
                class: "mime-bundle",
                collapse: "true"
              }, null, 8, ["mime-bundle"]))
            : (output.output_type == 'error')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(output.output_type)
                }, [
                  _createVNode(BeakerMimeBundle, {
                    "mime-bundle": rebundleError(output),
                    collapse: "true"
                  }, null, 8, ["mime-bundle"])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(output), 1))
      ], 2))
    }), 128))
  ]))
}
}

})